module.exports = "https://static.wmbcdn.com/uniweb/images/a49edb7244a48338d4fadaeaa7bcf4db.svg";